import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { createDraft } from '@services/partnerService';
import { usePartnerAuth } from '../PartnerAuthContext';
import { Button, Card, ErrorNote, Field, Muted, Title } from '../ui';

const CreateCommerce = () => {
  const { token } = usePartnerAuth();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');
  const [ownerNombre, setOwnerNombre] = useState('');
  const [ownerEmail, setOwnerEmail] = useState('');
  const [ownerWhatsapp, setOwnerWhatsapp] = useState('');

  const onCreate = async (e: FormEvent) => {
    e.preventDefault();
    if (!token) return;
    setError(null);
    setCreating(true);
    try {
      const res = await createDraft(token, {
        negocio: { nombre: nombre.trim(), direccion: direccion.trim() || undefined },
        owner: { nombre: ownerNombre.trim(), email: ownerEmail.trim(), whatsapp: ownerWhatsapp.trim() || undefined },
        monthly_orders: 'menos_de_100',
        product_interest: ['menu'],
      });
      navigate(`/partner/comercios/${res.id_comercio}`);
    } catch {
      setError('No se pudo crear el comercio. Revisa los datos.');
      setCreating(false);
    }
  };

  return (
    <>
      <Title sub="Crea el comercio y su suscripcion FREEMIUM. Luego podras cargar el menu y generar el link para el dueno.">
        Nuevo comercio
      </Title>
      <Card style={{ maxWidth: 520 }}>
        <form onSubmit={onCreate}>
          <Muted style={{ marginTop: 0, marginBottom: 12, fontWeight: 600, color: '#253746' }}>Negocio</Muted>
          <Field label="Nombre del negocio" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
          <Field label="Direccion (opcional)" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
          <Muted style={{ marginTop: 8, marginBottom: 12, fontWeight: 600, color: '#253746' }}>Dueno</Muted>
          <Field
            label="Nombre del dueno"
            value={ownerNombre}
            onChange={(e) => setOwnerNombre(e.target.value)}
            required
          />
          <Field
            label="Email del dueno"
            type="email"
            value={ownerEmail}
            onChange={(e) => setOwnerEmail(e.target.value)}
            required
          />
          <Field
            label="WhatsApp del dueno"
            value={ownerWhatsapp}
            onChange={(e) => setOwnerWhatsapp(e.target.value)}
            placeholder="+52..."
          />
          {error && <ErrorNote>{error}</ErrorNote>}
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Button type="submit" disabled={creating}>
              {creating ? 'Creando...' : 'Crear comercio'}
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/partner/comercios')}
              disabled={creating}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </Card>
    </>
  );
};

export default CreateCommerce;
